module.exports = __webpack_public_path__ + "img/servicesStepOne.0c22e8f4.webp";